import { GET_TAGS, SET_TAGS } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false
};

const tagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TAGS:
      return { ...state, isLoading: true };
    case SET_TAGS:
      return {
        ...state,
        list: action.tags,
        isLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
};

export default tagsReducer;
